// P0-10 Today board fixtures. Fake. Separated so fixtures.ts stays under
// the file-size cap and the Today board data is easy to tweak alone.

export type TodayCard = {
  id: string;
  title: string;
  subtitle?: string;
  tone: "info" | "warn" | "danger" | "ok";
  meta?: string;
  action?: string;
};

export const todayBoard = {
  openForm4473s: [
    {
      id: "b-1",
      title: "Fake Name One — Glock 19 Gen 5",
      subtitle: "On buyer tablet · 3 min in",
      tone: "info" as const,
      action: "Open",
    },
    {
      id: "b-2",
      title: "Fake Name Five — Ruger 10/22",
      subtitle: "Texted PIN · expires in 2 min",
      tone: "warn" as const,
      action: "Open",
    },
  ],
  nicsDelayed: [
    {
      id: "n-1",
      title: "Fake Name Two — S&W Shield Plus",
      subtitle: "Earliest proceed Oct 22 · $427 held",
      tone: "warn" as const,
      action: "Open",
    },
    {
      id: "n-2",
      title: "Fake Name Six — Glock 43X",
      subtitle: "Clear to proceed today · call customer",
      tone: "ok" as const,
      action: "Open",
    },
  ],
  nfa: [
    {
      id: "f-1",
      title: "Fake Name Three — Dead Air Sandman-S",
      subtitle: "Form 4 pending · 60 days in",
      tone: "info" as const,
      action: "Open",
    },
    {
      id: "f-2",
      title: "Fake Name Seven — SilencerCo Omega",
      subtitle: "Approved · waiting on pickup",
      tone: "ok" as const,
      action: "Schedule pickup",
    },
  ],
  transfers: [
    {
      id: "x-1",
      title: "Fake Name Three — Sig P365",
      subtitle: "Here since Oct 11 · customer notified",
      tone: "ok" as const,
      action: "Schedule pickup",
    },
    {
      id: "x-2",
      title: "Fake Name Eight — Beretta 92FS",
      subtitle: "Here 18 days · follow up today",
      tone: "warn" as const,
      action: "Call customer",
    },
  ],
  gunsmithing: [
    {
      id: "g-1",
      title: "Fake Name Nine — 1911 trigger job",
      subtitle: "In service · promised Oct 25",
      tone: "info" as const,
      action: "Open",
    },
    {
      id: "g-2",
      title: "Fake Name Ten — Remington 870 extractor",
      subtitle: "Overdue 4 days · promised Oct 15",
      tone: "danger" as const,
      action: "Call customer",
    },
  ],
  layaways: [
    {
      id: "l-1",
      title: "Fake Name Eleven — AR-15 build",
      subtitle: "Payment of $120 due today",
      tone: "warn" as const,
      action: "Message",
    },
  ],
  specialOrders: [
    {
      id: "o-1",
      title: "Fake Name Twelve — Trijicon RMR",
      subtitle: "In · customer not notified",
      tone: "warn" as const,
      action: "Text customer",
    },
  ],
  webOrders: [
    {
      id: "w-1",
      title: "3-item ship · $412",
      subtitle: "Picked · needs shipping label",
      tone: "info" as const,
      action: "Open",
    },
    {
      id: "w-2",
      title: "Firearm ship to FFL · $820",
      subtitle: "License not verified yet",
      tone: "warn" as const,
      action: "Verify FFL",
    },
  ],
  mnReportHolds: [
    {
      id: "m-1",
      title: "Fake Name Thirteen — S&W 442",
      subtitle: "Report filed Oct 17 · release Oct 24",
      tone: "info" as const,
      action: "Open",
    },
  ],
  compliance: [
    {
      id: "cp-1",
      title: "Form 3310.4 — Fake Name Fourteen",
      subtitle: "Due today · ATF filed · MN state pending",
      tone: "warn" as const,
      action: "Open",
    },
    {
      id: "cp-2",
      title: "Unsigned 4473 — Fake Name Fifteen",
      subtitle: "Yesterday · needs owner initials",
      tone: "danger" as const,
      action: "Open",
    },
    {
      id: "cp-3",
      title: "Davidson's FFL expiring",
      subtitle: "Expires in 12 days · request copy",
      tone: "warn" as const,
      action: "Request copy",
    },
  ],
  classes: [
    {
      id: "cl-1",
      title: "Permit to Carry · 2 pm",
      subtitle: "22 of 24 checked in",
      tone: "ok" as const,
      action: "Open roster",
    },
  ],
} as const;
